// extracted by mini-css-extract-plugin
export default {"container":"mainCard_container__y5oWv","titleBox":"mainCard_titleBox__k9xCO","title":"mainCard_title__Wvwz1","imageBox":"mainCard_imageBox__uv+Hy","image":"mainCard_image__laoJ6"};